module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('LinkPath', {
    attrs: {
      "current-path": "análise de fraude"
    }
  }), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "margin": "16px",
      "display": "none"
    },
    attrs: {
      "id": "divAlert",
      "role": "alert"
    }
  }), _vm._v(" "), (_vm.stringDivMessage !== '') ? _c('div', {
    class: ['alert', _vm.classDivMessage],
    staticStyle: {
      "margin": "16px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stringDivMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row input-row",
    staticStyle: {
      "align-items": "end"
    }
  }, [_c('div', {
    staticClass: "col-md-3 mb-3",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('label', {
    attrs: {
      "for": "dataIni"
    }
  }, [_vm._v("Data Início")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    staticClass: "datetime-picker",
    attrs: {
      "format": "dd/MM/yyyy",
      "language": _vm.ptBR,
      "id": "dataIni",
      "width": "100%",
      "required": ""
    },
    model: {
      value: (_vm.dtIni),
      callback: function($$v) {
        _vm.dtIni = $$v
      },
      expression: "dtIni"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateFim"
    }
  }, [_vm._v("Data Fim")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('datepicker', {
    staticClass: "datetime-picker",
    attrs: {
      "format": "dd/MM/yyyy",
      "language": _vm.ptBR,
      "id": "dateFim",
      "width": "100%",
      "required": ""
    },
    model: {
      value: (_vm.dtFim),
      callback: function($$v) {
        _vm.dtFim = $$v
      },
      expression: "dtFim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-primary button-color input-space",
    attrs: {
      "id": "btnPesq",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.findFrauds()
      }
    }
  }, [_vm._v("Pesquisar\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary input-space",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Limpar Filtros\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row input-row",
    staticStyle: {
      "gap": "1rem"
    }
  }, [_c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "safcode"
    }
  }, [_vm._v("\n                    Código SAF\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.safCode),
      expression: "safCode"
    }],
    staticClass: "input-spacing",
    attrs: {
      "type": "text",
      "id": "safcode"
    },
    domProps: {
      "value": (_vm.safCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.safCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("\n                    Status\n                  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "input-spacing",
    attrs: {
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN_ANALISIS"
    }
  }, [_vm._v("Em análise")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FRAUD_CONFIRMED"
    }
  }, [_vm._v("Fraude confirmada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FRAUD_NOT_CONFIRMED"
    }
  }, [_vm._v("Fraude não confirmada")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "editFraud",
      "data-toggle": "divViewFraud",
      "href": "#divViewFraud",
      "role": "button",
      "data-target": "#divViewFraud",
      "aria-expanded": "false",
      "aria-controls": "divViewFraud"
    },
    on: {
      "click": function($event) {
        return _vm.toggleClassByName('show', '#divViewFraud')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box box-info .collapse",
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "5px",
      "margin-left": "1.5%",
      "width": "97%",
      "display": "none"
    },
    attrs: {
      "id": "divViewFraud"
    }
  }, [_c('h3', [_vm._v("Editar registro de Fraude")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "statusEdit"
    }
  }, [_vm._v("Detalhes")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("IDN:")]), _vm._v(" " + _vm._s(_vm.fraudEdit.idn))]), _vm._v(" "), _c('li', [_c('b', [_vm._v("CPF:")]), _vm._v(" " + _vm._s(_vm.fraudEdit.cpf))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "safCodeEdit"
    }
  }, [_vm._v("Código SAF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fraudEdit.safCode),
      expression: "fraudEdit.safCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "safCodeEdit",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.fraudEdit.safCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fraudEdit, "safCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "statusEdit"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fraudEdit.status),
      expression: "fraudEdit.status"
    }],
    staticClass: "input-spacing",
    attrs: {
      "id": "statusEdit",
      "disabled": _vm.hideStatusButton
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fraudEdit, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "IN_ANALISIS"
    }
  }, [_vm._v("Em análise")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FRAUD_CONFIRMED"
    }
  }, [_vm._v("Fraude confirmada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FRAUD_NOT_CONFIRMED"
    }
  }, [_vm._v("Fraude não confirmada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-md-5 mb-3",
    staticStyle: {
      "margin-top": "5px",
      "display": "flex",
      "flex-direction": "column",
      "gap": "1rem"
    }
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fraudEdit.description),
      expression: "fraudEdit.description"
    }],
    attrs: {
      "rows": "6",
      "cols": "80",
      "id": "description",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.fraudEdit.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fraudEdit, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 mb-3",
    staticStyle: {
      "margin-top": "5px",
      "margin-left": "8%",
      "display": "flex",
      "flex-direction": "column",
      "gap": "1rem"
    }
  }, [_c('label', {
    attrs: {
      "for": "conclusion"
    }
  }, [_vm._v("Conclusão")]), _vm._v(" "), (!_vm.fraudEdit.userAudit) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fraudEdit.conclusion),
      expression: "fraudEdit.conclusion"
    }],
    attrs: {
      "rows": "6",
      "cols": "80",
      "id": "conclusion",
      "disabled": _vm.hideStatusButton
    },
    domProps: {
      "value": (_vm.fraudEdit.conclusion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fraudEdit, "conclusion", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fraudEdit.userAudit) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fraudEdit.conclusion),
      expression: "fraudEdit.conclusion"
    }],
    attrs: {
      "rows": "6",
      "cols": "80",
      "id": "conclusion",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.fraudEdit.conclusion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fraudEdit, "conclusion", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 mb-1",
    staticStyle: {
      "margin-bottom": "5px",
      "margin-left": "-1.5%"
    }
  }, [(_vm.check('SAVE') && !_vm.hideSaveButton && !_vm.hideStatusButton) ? _c('div', {
    staticClass: "col-md-1 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Salvar")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 mb-3",
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("Cancelar")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "divBlank",
    attrs: {
      "id": "divblank"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "divTab"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "tabFraud_wrapper"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tabFraud",
      "role": "grid",
      "id": "tabFraud"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.listaFraud), function(fraud, index) {
    return _c('tr', {
      key: fraud.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('a', {
      attrs: {
        "href": "#",
        "title": "Visualizar Ocorrência"
      },
      on: {
        "click": function($event) {
          return _vm.editFraud(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "margin-left": "35%"
      }
    })])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-sort": "<%= audit.formatDate.strftime('%Y%m%d%H%M%s') %>"
      }
    }, [_vm._v("\n                                  " + _vm._s(fraud.formatCreationDate) + "\n                                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fraud.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fraud.safCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fraud.userAudit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fraud.translateStatus))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#",
        "title": "Download Nist"
      },
      on: {
        "click": function($event) {
          return _vm.downloadNist(fraud)
        }
      }
    }, [_vm._v("NIST")])]), _vm._v(" "), _c('td', [(!fraud.process && fraud.userAudit !== '') ? _c('a', {
      attrs: {
        "href": "#",
        "title": "Ação não processada ou com erro.",
        "data-toggle": "modal",
        "data-target": "#fraudeModal"
      },
      on: {
        "click": function($event) {
          return _vm.preSend(fraud.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "margin-left": "35%"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (fraud.process) ? _c('a', {
      attrs: {
        "href": "#",
        "title": "Ação processada com sucesso."
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle",
      staticStyle: {
        "margin-left": "35%"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (!fraud.process && fraud.userAudit === '') ? _c('a', {
      attrs: {
        "href": "#",
        "title": "Ação aguardando análise."
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle",
      staticStyle: {
        "margin-left": "35%"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(4)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "fraudeModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "fraudeModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.reProcessing()
      }
    }
  }, [_vm._v("\n                    Enviar\n                  ")])])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon date-input"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon date-input"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "tabFraud_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("Ação")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("Data/Hora")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("Reportado por")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("Código SAF")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("Analisado por")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("NIST")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabFraud",
      "tabindex": "0"
    }
  }, [_vm._v("Processado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Ação")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Data/Hora")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Reportado por")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Código SAF")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Analisado por")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("NIST")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Processado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-color": "#3c8dbc"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "id": "fraudeModalLabel"
    }
  }, [_vm._v("Registro de\n                    Fraude")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Deseja reenviar para processamento?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d92d746"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/views/Fraud.vue
// module id = 252
// module chunks = 0